<template>

  <div class="ob-button-group">
    <slot></slot>
  </div>

</template>

<script>
  export default {
    name: 'ob-button-group'
  }
</script>

<style scoped lang="scss">

  @import '../../../assets/variables';
  @import '../../../assets/responsive';

  .ob-button-group {
    display: inline-flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;

    ::v-deep {
      & > * {
        margin-left: $spacing-default;

        @include media('<tablet') {
          margin-bottom: $spacing-default;
        }
      }
    }
  }

</style>
